"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ManualDepositWorkflowComponent = _interopRequireDefault(require("./ManualDepositWorkflowComponent"));
var _depositWithdrawalSelectors = require("../../../../redux/selectors/depositWithdrawalSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var onSubmit = _ref.onSubmit,
    submitting = _ref.submitting;
  return {
    product: (0, _depositWithdrawalSelectors.depositProductSelector)(state),
    onSubmit: onSubmit,
    submitting: submitting
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_ManualDepositWorkflowComponent["default"]);